import { render, staticRenderFns } from "./ExchangeCalculator.vue?vue&type=template&id=e143debc&scoped=true&"
import script from "./ExchangeCalculator.vue?vue&type=script&lang=js&"
export * from "./ExchangeCalculator.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeCalculator.vue?vue&type=style&index=0&id=e143debc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e143debc",
  null
  
)

export default component.exports